import { useState } from 'react';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { communityData } from '../../components/Tab/TabData';

import Input from '../../components/TextField/Input';
import Textarea from '../../components/TextField/Textarea';
import { Button } from '../../components/Button/Button';
import { fetchPostWithFiles } from '../../hooks/fetch';
import { validateStr } from '../../hooks/useValidate';
import useFiles from '../../hooks/useFiles';
import { getTokenPayload, getUserToken } from '../../hooks/useLogin';
import { openAlert } from '../../components/Modal/MsgBox';

export default function Inquiry() {
	const [activeTab, setActiveTab] = useState('');
	const [inquiryInfo, setInquiryInfo] = useState({ title: "", content: "" });
	const [files, handleFileChange, deleteFile, toFormData] = useFiles();

	const onChangeInquiryInfo = (e) => {
		setInquiryInfo({
			...inquiryInfo,
			[e.target.name]: e.target.value
		});
	}

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '1대1 문의';

	const validateInfo = () => {
		if(getUserToken() === '' && getTokenPayload()?.id === 0) {
			openAlert(
				"로그인이 필요한 서비스입니다.",
				() => { window.location.replace("/account/login") }
			);
			return false;
		}

		return validateStr(inquiryInfo.title, "문의 제목을")
			&& validateStr(inquiryInfo.content, "문의 내용을");
	}

	function save(e) {
		e.preventDefault();
		if(!validateInfo()) return;

		fetchPostWithFiles(
			`/inquiry`,
			"문의를 저장",
			toFormData(inquiryInfo),
			() => {
				setInquiryInfo({});
				window.location.reload();
			}
		)
	}

	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 보기 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={communityData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div className="inquiry-enter-con">
						<div className="top">
							<p className="fc-vivid-red gs-bullet asterisk">
								관리자가 답변을 하면, 마이페이지 &gt; 내 문의에서 확인하실 수 있습니다.
							</p>
						</div>
						<div>
							<Input.Group className="enter-group-row">
								<Input
									id="inquiry-title"
									type="text"
									placeholder="문의 제목을 입력하세요."
									showLabel
									essential
									label="문의 제목"
									name="title"
									value={inquiryInfo.title}
									onChange={onChangeInquiryInfo}
									maxLength={100}
								/>
								<Textarea
									id="inquiry-content"
									placeholder="문의 내용을 입력하세요."
									showLabel
									essential
									label="문의 내용"
									name="content"
									value={inquiryInfo.content}
									onChange={onChangeInquiryInfo}
								/>
								<div className="gs-file-wrap">
									<div className="label">첨부파일</div>
									<div className="gs-files-con">
										<div className="gs-file-upload">
											<input type="file" accept="" multiple={5} onChange={handleFileChange}/>
											<Button type="button" className="cyan" tabIndex={-1}>파일 업로드</Button>
										</div>
										<ul className="gs-files">
											{files !== undefined && files.map((f, i) => {
												return (
													<li key={i}>
														<a
															href={URL.createObjectURL(f)}
															download={f.name}
															role="button"
															className="file gs-underline-item blue"
														>
															<span className="line">{f.name}</span>
														</a>
														<div className="controls">
															<Button type="button" className="remove" title="삭제" onClick={() => deleteFile(i)}>
																<span className="sr-only">삭제</span>
															</Button>
														</div>
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							</Input.Group>
						</div>
						<div className="gs-bottom-btns center line">
							<Button onClick={save}>문의하기</Button>
						</div>
					</div>
				</div>
			</Container>
		</main>
	);
}
